module.exports = __webpack_public_path__ + "static/media/demon.4c9a7c8b.gif";